import React from "react";
// import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./views/home";
import { FbProvider } from "./FbContex";

export default function App() {
  return (
    // <div className="App">
    <FbProvider>
      <BrowserRouter>
        <Switch>
          <Route path="/" component={Home} />
        </Switch>
      </BrowserRouter>
    </FbProvider>
    // </div>
  );
}
